import { catchError, map, of } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { environment } from '../../../../environment/environment';

export function orgPathVersions(componentDataSourceService: ComponentDataSourceService) {
  return {
    name: 'Organization Path Versions',
    description: 'Lists all educational path versions in the current organization',
    execute: () => {
      return componentDataSourceService.http
        .get(`${environment.apiUrl}/paths/versions/org`)
        .pipe(
          catchError((error) => {
            console.error('Error fetching organization path versions:', error);
            return of([]);
          }),
          map((result: any) => {
            if (!Array.isArray(result)) {
              return [];
            }
            return result.map((version: any) => ({
              ...version,
              display_name: version.display_name || `${version.path_name} – ${version.version_name}`,
            }));
          })
        );
    },
    settings: {
      columns: [
        { key: 'version_id', header: 'ID', type: 'number' },
        { key: 'display_name', header: 'Version', type: 'text' },
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      defaultSortColumn: 'display_name',
      defaultSortDirection: 'asc',
    },
  };
}
